// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"4b3761c1","599":"a6699cef"}[chunkId] + ".chunk.css";
};